window.__PSN_BUILD_INFO__ = __PSN_BUILD_INFO__;
